import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import Dropdown from '../dropdown/dropdown'
import { ErrorPopover } from '../popover/error-popover'
import IconDropdownHeader from './icon-dropdown-header'

import styles from './icon-dropdown.module.css'

const listItemPropTypes = {
    children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    className: PropTypes.string,
    icon: PropTypes.element,
    onClick: PropTypes.func,
    selected: PropTypes.bool
}

const listItemDefaultProps = {
    icon: <div className={styles['default-icon']} />
}

// A slightly modified version of the ListItem component to include checkboxes
const ListItem = props => {
    const { children, className, icon, onClick } = props
    const iconElement = icon ? <div className={styles['icon']}>{icon}</div> : null
    return (
        <div className={cx(styles['list-item'], className)} onClick={onClick}>
            <div className={styles['wrapper']}>
                {iconElement}
                <div className={styles['content']}>{children}</div>
            </div>
        </div>
    )
}

ListItem.propTypes = listItemPropTypes
ListItem.defaultProps = listItemDefaultProps

/**
 * Extends Dropdown to show an icon before each list item.
 *
 * Usage:
 * <IconDropdown />
 *
 * The list item icon is expected to be part of the item object as attribute 'icon'.
 * The icon should have a size of 14 x 14 px.
 */

const iconDropdownPropTypes = Object.assign({}, Dropdown.propTypes)

class IconDropdown extends Dropdown {
    getListItemClass() {
        return ListItem
    }

    render() {
        const { className, error, style } = this.props
        const composedClassName = cx(
            'tag',
            styles['dropdown'],
            {
                [styles['dropdown-open']]: this.state.dropdownOpen,
                [styles['error']]: error
            },
            className
        )

        return (
            <ErrorPopover error={error} placement="top">
                <div className={composedClassName} style={style}>
                    {this.renderHeader()}
                    {this.renderList()}
                </div>
            </ErrorPopover>
        )
    }

    renderItem(item) {
        const { itemKey, itemTitle, showFilter } = this.props
        const selected = this.isItemSelected(item)
        const className = cx('t3sel-dropdown-list-item', styles['list-item'], {
            [styles['list-item-selected']]: selected
        })
        const ListItem = this.getListItemClass()
        const icon = item.icon

        if (showFilter) {
            return (
                <ListItem
                    key={item[itemKey]}
                    className={className}
                    selected={selected}
                    onClick={() => {
                        this.onChoiceClick.bind(this)(item)
                    }}
                    name={item[itemTitle]}
                    icon={icon}
                />
            )
        }
        return (
            <ListItem
                key={item[itemKey]}
                className={className}
                selected={selected}
                onClick={() => {
                    this.onChoiceClick.bind(this)(item)
                }}
                icon={icon}
            >
                {item[itemTitle]}
            </ListItem>
        )
    }

    renderHeader() {
        const { disabled, error, headerClassName, icon, itemTitle, placeholder } = this.props
        const selectedItem = this.state.selected
        const selectedItemName = selectedItem ? selectedItem[itemTitle] : null
        const selectedItemIcon = selectedItem ? selectedItem.icon : null
        return (
            <IconDropdownHeader
                item={selectedItemName}
                itemIcon={selectedItemIcon}
                {...{ disabled, error, headerClassName, icon, placeholder }}
            />
        )
    }
}

IconDropdown.propTypes = iconDropdownPropTypes

export default IconDropdown
